export const CARD_HEAD_STYLES = {
  border: 'none',
};

export const CARD_BODY_STYLES = {
  paddingTop: 0,
};

// TODO: 暫時的資料，換成真實資料後記得刪除
export const DUMMY_TICKET_CATEGORY_OPTIONS = [
  {
    label: '春季活動半價券',
    value: '春季活動半價券',
  },
  {
    label: '三八婦女節優惠券',
    value: '三八婦女節優惠券',
  },
  {
    label: '試營運券',
    value: '試營運券',
  },
];
